import { Notification as customNotification } from '../../components/ui/custom-notification';
import get from 'lodash/get';
import axiosConfig from './axiosConfig';
import axios from 'axios';
import { handleExcelDownload } from '../../utils/excelUtils';


export const AddMaterial = async (materialData, isEdit) => {
  try {
    let res;

    const url = `/materialTraceability/createMaterialTraceability`;

    res = await axiosConfig.post(url, materialData);



    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      customNotification.success(
        'Material Added Successfully',
        'The material has been added successfully.'
      );
      return res.data;
    }
    if (res.status === 502) {
      customNotification.error('Service temporarily unavailable', 'The service is temporarily unavailable. Please try again later.');
      return null;
    }
    return null;
  } catch (error) {

    const pipeLikeCategories = ['Pipe', 'Bends', 'Flanges', 'Reducer', 'T-Piece', 'Weldolet', 'End Cap', 'Sweepolet', 'Hydro', 'Torquing', 'Gauging', 'Flushing'];
    if (error.statusCode === 410 && pipeLikeCategories.includes(materialData.data[0].materialCategory)) {
      customNotification.warning('Pipe number ' + materialData.data[0].details.pipeNo + ' already exists. Please enter a unique pipe number..');
      return null;
    }
    else if (error.statusCode === 410 && materialData.data[0].materialCategory === 'Forge') {
      customNotification.warning('Forge serial number ' + materialData.data[0].details.forgeSerialNumber + ' already exists. Please enter a unique forge serial number..');
      return null;
    }
    else if (error.statusCode === 410 && materialData.data[0].materialCategory === 'Gas') {
      customNotification.warning('Gas serial number ' + materialData.data[0].details.gasSerialNumber + ' already exists. Please enter a unique gas serial number..');
      return null;
    }
    else if (error.statusCode === 410 && materialData.data[0].materialCategory === 'Wire Lot') {
      customNotification.warning('Wire lot number ' + materialData.data[0].details.wireLotNumber + ' already exists. Please enter a unique wire lot number..');
      return null;
    }
    const errorMessage = error.response?.data?.message || error.message || 'Failed to add material';
    customNotification.error('Failed to add material', errorMessage);
    return null;
  }
}


export const GetAllMaterials = async (payload) => {
  try {
    const projectId = payload?.project_id != null && payload.project_id !== '' ? String(payload.project_id) : null;
    const projectTypeId = payload?.project_type_id != null && payload.project_type_id !== '' ? String(payload.project_type_id) : null;
    const pipeId = payload?.pipe_id != null && payload.pipe_id !== '' ? String(payload.pipe_id) : '-1';
    if (projectId == null || projectTypeId == null) return {};
    const url = `/materialTraceability/getMaterialTraceabilityData?project_id=${encodeURIComponent(projectId)}&project_type_id=${encodeURIComponent(projectTypeId)}&pipe_id=${encodeURIComponent(pipeId)}`;

    const res = await axiosConfig.get(url);
    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    } if (res.status === 200) {
      const data = get(res, ['data', 'data'], {});
      return data || {};
    }
    return [];
  } catch (error) {
    customNotification.error('Failed to fetch materials', error.data);
    return [];
  }
};

export const GetProjectMaterialOverview = async (projectId) => {
  try {
    const url = `/materialTraceability/getProjectMaterialOverview?project_id=${projectId}`;
    const res = await axiosConfig.get(url);

    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      return get(res, ['data', 'data'], null);
    }
    return null;
  } catch (error) {
    customNotification.error('Failed to fetch material overview', error.response?.data?.message || error.message || 'Failed to fetch material overview');
    return null;
  }
};


// Function to upload files to S3
export const getPreSignedUrlToUpload = async (fileList, payload, version = 1) => {
  try {
    const uploadedFiles = [];

    if (fileList && fileList.length > 0) {
      // Create file objects for all files
      const fileObjs = fileList.map(file => ({
        fileName: file.name.replace(/\(\d+\)/g, "").trim(), // Remove (1), (2), etc.
        contentType: file.type,
        pipeId: payload.pipeId,
        projectId: payload.projectId,
        projectTypeId: payload.projectTypeId,
        materialCategory: payload.materialCategory,
        fileSize: file.size, // Use actual file size
        version: version || 1
      }));


      // Get signed URLs for all files at once
      const response = await axiosConfig.post(`/materialTraceability/getPresignedUrlToUploadTraceabilityDoc`, fileObjs);

      if (response.status === 200) {
        const presignedData = response.data.data;

        // Process each presigned URL
        for (const data of presignedData) {
          const file = fileList.find(f => f.name.replace(/\(\d+\)/g, "").trim() === data.fileName);

          if (file) {

            // Validate presigned URL data
            if (!data.presignedUrl) {
              customNotification.error('Upload Failed', 'Failed to get upload URL from server.');
              continue; // Skip this file and continue with next
            }

            try {
              // Log the presigned URL (remove sensitive parts for security)
              const urlParts = data.presignedUrl.split('?');


              // Small delay to ensure URL is ready (optional)
              await new Promise(resolve => setTimeout(resolve, 100));

              // Upload file to S3
              const uploadResponse = await axios.put(data.presignedUrl, file, {
                headers: {
                  "Content-Type": data.contentType || file.type || "application/octet-stream",
                  // "Content-Disposition": `attachment; filename="${file.name}"`
                },
                // Add timeout to prevent hanging requests
              //  timeout: 1000000,
              });

              if (uploadResponse.status === 200) {
                uploadedFiles.push({ s3Key: data.s3Key, fileName: data.fileName });
              } else {
                customNotification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
              }
            } catch (error) {
              // Add more detailed error logging
              if (error.response) {
              }
              // Show user-friendly error
              customNotification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
            }
          } else {
            customNotification.error('File Upload Failed', `File ${data.fileName} not found.`);
          }
        }
      } else {
        customNotification.error('Upload Failed', 'Failed to get upload URLs from server.');
      }

    }
    return uploadedFiles;
  } catch (error) {
    return []; // Return empty array on error
  }
};
// Function to upload files to S3
export const getSimplePresignedUrlToUpload = async (fileList, payload, version = 1) => {
  try {
    const uploadedFiles = [];

    if (fileList && fileList.length > 0) {
      // Create file objects for all files
      const fileObjs = fileList.map(file => ({
        fileName: file.name.replace(/\(\d+\)/g, "").trim(), // Remove (1), (2), etc.
        contentType: file.type,
        pipeId: payload.pipeId,
        projectId: payload.projectId,
        projectTypeId: payload.projectTypeId,
        materialCategory: payload.materialCategory,
        fileSize: file.size, // Use actual file size
        version: version || 1
      }));


      // Get signed URLs for all files at once
      const response = await axiosConfig.post(`pipeDocuments/getSimplePreSignedUrl`, fileObjs);

      if (response.status === 200) {
        const presignedData = response.data.data;

        // Process each presigned URL
        for (const data of presignedData) {
          const file = fileList.find(f => f.name.replace(/\(\d+\)/g, "").trim() === data.fileName);

          if (file) {

            // Validate presigned URL data
            if (!data.presignedUrl) {
              customNotification.error('Upload Failed', 'Failed to get upload URL from server.');
              continue; // Skip this file and continue with next
            }

            try {
              // Log the presigned URL (remove sensitive parts for security)
              const urlParts = data.presignedUrl.split('?');


              // Small delay to ensure URL is ready (optional)
              await new Promise(resolve => setTimeout(resolve, 100));

              // Upload file to S3
              const uploadResponse = await axios.put(data.presignedUrl, file, {
                headers: {
                  "Content-Type": data.contentType || file.type || "application/octet-stream",
                  // "Content-Disposition": `attachment; filename="${file.name}"`
                },
                // Add timeout to prevent hanging requests
                //timeout: 100000,
              });

              if (uploadResponse.status === 200) {
                uploadedFiles.push({ s3Key: data.s3Key, fileName: data.fileName });
              } else {
                customNotification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
              }
            } catch (error) {
              // Add more detailed error logging
              if (error.response) {
              }
              // Show user-friendly error
              customNotification.error('File Upload Failed', `Failed to upload ${file.name}. Please try again.`);
            }
          } else {
            customNotification.error('File Upload Failed', `File ${data.fileName} not found.`);
          }
        }
      } else {
        customNotification.error('Upload Failed', 'Failed to get upload URLs from server.');
      }

    }
    return uploadedFiles;
  } catch (error) {
    return []; // Return empty array on error
  }
};



export const deleteMaterials = async (materialIds, type) => {
  try {

    // Handle both single pipeId and array of pipeIds
    const materialIdsArray = Array.isArray(materialIds) ? materialIds : [materialIds];
    const res = await axiosConfig.post(`/materialTraceability/bulkDeleteMaterialTraceability`, {
      "data": {
        "materialIds": materialIdsArray
      }
    });


    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      customNotification.success('Materials deleted successfully', `${type} materials have been deleted`);
      return res;
    }

  } catch (error) {
    customNotification.error('Failed to delete documents', error.data || error.message);
    return null;
  }
}



export const AddMaterialCategory = async (data, type = 'material') => {

  try {
    let url = '/tags/createTag';
    const res = await axiosConfig.post(url, data);

    customNotification.destroy();
    if (res.status === 200) {
      const responseData = get(res, ['data', 'data'], {});

      customNotification.success('Added Successfully.', 'The ' + type + ' was added successfully.');

      return responseData

    }

    else {

      customNotification.error('Failed to add  ' + type, 'Please try again');
      return null

    }


  } catch (error) {

    if (error.data.includes('Validation error')) {
      customNotification.warning(`${data.tags_name} already exists`, 'Please enter a different ' + type + ' name');
    }
    else {
      customNotification.error('Failed to add  ' + type, error.data);
    }
    return null

  }
}

export const getListMaterialCategory = async (type) => {
  try {
    let url;
    if (type) {
      url = `/tags/getAllTags?tags_type=${type}`;
    } else {
      url = `/tags/getAllTags`;
    }



    const res = await axiosConfig.get(url);


    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    } if (res.status === 200) {
      const data = get(res, ['data', 'data'], {});

      return data?.tags || [];
    }
    return [];
  } catch (error) {

    // Check for specific error types
    if (error.code === 'NETWORK_ERROR') {
      customNotification.error('Network Error', `Unable to connect to server while fetching ${type}`);
    } else if (error.response?.status === 401) {
      customNotification.error('Authentication Error', `Your session has expired while fetching ${type}`);
    } else if (error.response?.status === 403) {
      customNotification.error('Permission Denied', `You do not have permission to access ${type}`);
    } else if (error.response?.status >= 500) {
      customNotification.error('Server Error', `Server error while fetching ${type}. Please try again later.`);
    } else {
      customNotification.error(`Failed to fetch ${type} category`, error.error || error.message);
    }
    return [];
  }
};



export const getMaterialsTemplate = async (projectId, projectTypeId, type) => {
  try {


    // Create a custom axios instance for this request to handle blob response

    const res = await axiosConfig.post(`/utils/generateExcelTemplate`, {
      fileName: type,
      fileType: "excel",
      projectId: projectId,
      projectTypeId: projectTypeId
    });



    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      // Use the comprehensive download handler
      const result = await handleExcelDownload(res.data?.data?.downloadUrl, `Material_Traceability_Template.xlsx`);

      if (result.success) {
        customNotification.success('Material Traceability template downloaded successfully', `Material Traceability template has been downloaded successfully`);
      } else {
        customNotification.error('Download failed', result.error);
      }

      return res.data;
    }
    return null;

  } catch (error) {
    customNotification.error('Failed to download template', error.data || error.message);
    return null;
  }
}

export const updateMaterialTraceability = async (materialData, category = '', isSegmentation = false, isBatch = false) => {
  try {
    const url = `/materialTraceability/bulkUpdateMaterialTraceability`;

    const res = await axiosConfig.put(url, materialData);

    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      if (isBatch) {
        customNotification.success(
          'Material Batch Certificate Updated Successfully',
          'The material batch certificate has been updated successfully.'
        )
        return res.data;
      }
      else {
        category !== '' && !isSegmentation ? customNotification.success(
          'Material Updated Successfully',
          `The ${category} material has been updated successfully.`
        ) : isSegmentation ? customNotification.success(
          'Pipe Segmentation Updated Successfully',
          'The pipe segmentation has been updated successfully.'
        ) : customNotification.success(
          'Material Updated Successfully',
          'The material has been updated successfully.'
        )
      }
      return res.data;
    }
    if (res.status === 502) {
      customNotification.error('Service temporarily unavailable', 'The service is temporarily unavailable. Please try again later.');
      return null;
    }
    return null;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update material';
    customNotification.error('Failed to update material', errorMessage);
    return null;
  }
}



/** Warehouse / unassigned pipe inventory — separate from project-scoped create. */
export const createWarehouseMaterialTraceability = async (materialData) => {
  try {
    const url = `/materialTraceability/createWarehouseMaterialTraceability`;
    const res = await axiosConfig.post(url, materialData);

    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200 || res.status === 201) {
      customNotification.success(
        'Warehouse pipe added',
        'The pipe inventory record was saved (no project/pipe setup required).'
      );
      return res.data;
    }
    if (res.status === 502) {
      customNotification.error(
        'Service temporarily unavailable',
        'The service is temporarily unavailable. Please try again later.'
      );
      return null;
    }
    return null;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to add warehouse material';
    if (error.response?.status === 404) {
      customNotification.error(
        'Warehouse API not available',
        'Backend endpoint createWarehouseMaterialTraceability is not deployed yet. See docs/agents/warehouse-material-traceability-api.md.'
      );
      return null;
    }
    customNotification.error('Failed to add warehouse material', errorMessage);
    return null;
  }
};

/** Presigned upload for warehouse materials (nullable projectId / pipeId). */
export const getPreSignedUrlToUploadWarehouseDoc = async (fileList, payload, version = 1) => {
  try {
    const uploadedFiles = [];

    if (fileList && fileList.length > 0) {
      const fileObjs = fileList.map((file) => ({
        fileName: file.name.replace(/\(\d+\)/g, '').trim(),
        contentType: file.type,
        pipeId: payload.pipeId ?? null,
        projectId: payload.projectId ?? null,
        projectTypeId: payload.projectTypeId ?? null,
        materialCategory: payload.materialCategory || 'Pipe',
        materialId: payload.materialId ?? null,
        isWarehouseInventory: true,
        fileSize: file.size,
        version: version || 1,
      }));

      const response = await axiosConfig.post(
        `/materialTraceability/getPresignedUrlToUploadWarehouseDoc`,
        fileObjs
      );

      if (response.status === 200) {
        const presignedData = response.data.data;

        for (const data of presignedData) {
          const file = fileList.find(
            (f) => f.name.replace(/\(\d+\)/g, '').trim() === data.fileName
          );

          if (file) {
            if (!data.presignedUrl) {
              customNotification.error('Upload Failed', 'Failed to get upload URL from server.');
              continue;
            }

            try {
              await new Promise((resolve) => setTimeout(resolve, 100));
              const uploadResponse = await axios.put(data.presignedUrl, file, {
                headers: {
                  'Content-Type': data.contentType || file.type || 'application/octet-stream',
                },
              });

              if (uploadResponse.status === 200) {
                uploadedFiles.push({ s3Key: data.s3Key, fileName: data.fileName });
              } else {
                customNotification.error(
                  'File Upload Failed',
                  `Failed to upload ${file.name}. Please try again.`
                );
              }
            } catch (error) {
              customNotification.error(
                'File Upload Failed',
                `Failed to upload ${file.name}. Please try again.`
              );
            }
          } else {
            customNotification.error('File Upload Failed', `File ${data.fileName} not found.`);
          }
        }
      } else {
        customNotification.error('Upload Failed', 'Failed to get upload URLs from server.');
      }
    }
    return uploadedFiles;
  } catch (error) {
    if (error.response?.status === 404) {
      customNotification.error(
        'Warehouse upload API not available',
        'Deploy getPresignedUrlToUploadWarehouseDoc or use create/update with documents embedded.'
      );
    }
    return [];
  }
};

export const updateWarehouseMaterialTraceability = async (materialData) => {
  try {
    const url = `/materialTraceability/updateWarehouseMaterialTraceability`;
    const res = await axiosConfig.put(url, materialData);

    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      customNotification.success(
        'Warehouse pipe updated',
        'The pipe inventory record was updated successfully.'
      );
      return res.data;
    }
    if (res.status === 502) {
      customNotification.error(
        'Service temporarily unavailable',
        'The service is temporarily unavailable. Please try again later.'
      );
      return null;
    }
    return null;
  } catch (error) {
    const errorMessage =
      error.response?.data?.message || error.message || 'Failed to update warehouse material';
    if (error.response?.status === 404) {
      customNotification.error(
        'Warehouse API not available',
        'Backend endpoint updateWarehouseMaterialTraceability is not deployed yet.'
      );
      return null;
    }
    customNotification.error('Failed to update warehouse material', errorMessage);
    return null;
  }
};

export const DeleteMaterialDocument = async (payload) => {
  try {

    // Handle both single pipeId and array of pipeIds
    const materialDocsIdsArray = Array.isArray(payload.materialDocsIds) ? payload.materialDocsIds : [payload.materialDocsIds];
    const res = await axiosConfig.post(`/materialTraceability/deleteMaterialTraceabilityDocumentsByDocId`, 
      {
      "docIds": materialDocsIdsArray
    });


    if (res.status === 403) {
      customNotification.error('Unauthorized', 'You do not have permission to access this resource.');
      return null;
    }
    if (res.status === 200) {
      customNotification.success('Document deleted successfully', 'Material document has been deleted');
      return res;
    }

  } catch (error) {
    customNotification.error('Failed to delete documents', error.data || error.message);
    return null;
  }
}
